
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { visualizerActions } from '../../store';

import FloorplanSummayCard from '../FloorplanSummaryCard/FloorplanSummaryCard';
import RoomsceneSwitcher from '../RoomsceneSwitcher/RoomsceneSwitcher';
import TopMenu from '../TopMenu/TopMenu';
import Visualizer from '../Visualizer/Visualizer';
import ShareModal from '../ShareModal/ShareModal';
import EmailShareModal from '../EmailShareModal/EmailShareModal';
import SendToSeagateModal from '../SendToSeagateModal/SendToSeagateModal';
import HelpModal from '../HelpModal/HelpModal';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import ProductMenu from '../ProductMenu/ProductMenu';

import styles from './VisualizerPage.module.css';


export default function VisualizerPage() {

    const urlParams = useParams();
    const dispatch = useDispatch();

    const activeFloorPlanData = useSelector((state) => state.visualizer.activeFloorPlanData);

    const shareModalStatus = useSelector((state) => state.ui.shareModalActive);
    const emailModalStatus = useSelector((state) => state.ui.emailModalActive);
    const sendToSeagateModalStatus = useSelector((state) => state.ui.sendToSeagateModalStatus);
    const helpModalStatus = useSelector((state) => state.ui.helpModalActive);
    const feedbackModalStatus = useSelector((state) => state.ui.feedbackModalActive);

    if(activeFloorPlanData === null){
        dispatch(visualizerActions.setActiveFloorplanFromID(parseInt(urlParams.floorplan)));
        dispatch(visualizerActions.setActiveFloorplanStepsFromID(parseInt(urlParams.floorplan)));
        return false;
    } 

    return (
        <>
            <TopMenu extended={true} />
            
            <section className={styles.visualizerView}>
                <div className={styles.content}>

                    <div className={styles.leftColumn}>
                       <FloorplanSummayCard/>
                       <RoomsceneSwitcher/>
                    </div>
                    <div className={styles.rightWrap}>
                    <div className={styles.centerColumn}>
                    <Visualizer />
                    </div>
                    <div className={styles.rightColumn}>
                       <ProductMenu />
                    </div>
                    </div>
                </div>
            </section>

            {shareModalStatus && <ShareModal/>}
            {emailModalStatus && <EmailShareModal />}
            {sendToSeagateModalStatus && <SendToSeagateModal/>}
            {helpModalStatus && <HelpModal />}
            {feedbackModalStatus && <FeedbackModal />}
        </>
    );
}

